<template>

<div :class="[cart ? '':'container-fluid']">


     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>


<div  v-if="type=='A'">



<div>

<fiscal-printer   v-if="fp" v-bind:coupon="fiscalData" v-bind:giftTicket="false" @close="fp=false" @finish="fp=false" ></fiscal-printer>  


<EpsonFiscalReceiptCoupon v-if="fiscalPrinter.show" v-bind:coupon="fiscalCoupon" @close="fiscalPrinter.show = 0"></EpsonFiscalReceiptCoupon>
<EpsonCoupon v-if="epsonCoupon" v-bind:coupon="coupon" @close="closeEpsonCoupon()"></EpsonCoupon>

<div class="card border-primary" >
  <div class="card-header bg-primary text-white">
    <h4><i style="color:#FFCC00" class="fas fa-gift mr-3"></i>
    LISTA COUPON </h4>
  </div>

  <div  class="btn-group mt-1 ml-1 mr-1" role="group" aria-label="Basic example">
    <button  v-if="cart"  @click="$emit('close')" type="button" class="btn btn-secondary">
     <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
    TORNA ALLA VENDITA</button>
  <button @click="createCoupon()" type="button" class="btn btn-success">
     <i  class="fas fa-edit mr-2" aria-hidden="true"></i>
    NUOVO COUPON</button>
  <button @click="searchCoupon()" type="button" class="btn btn-info">
     <i  class="fas fa-binoculars mr-2" aria-hidden="true"></i>
    RICERCA</button>

  
</div>



  <div class="card-body text-primary">

  <div>
   


  </div>    

  

    <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">              
    <table class="table table-hover table-bordered  table-sm mb-0" id="table">
    <thead>
     
      <tr class="sticky-row sticky-header">
        <th>
         # 
        </th>  
        <th>
          DATA  
        </th>  
        <th>
          IMPORTO  
        </th>  
        <th>
          PAGAMENTO
        </th>  
        
        <th>
            RIFERIMENTO 
        </th>    
        <th>
            TELEFONO
        </th>
        <th>
          SCADENZA  
        </th>
        <th>
          BARCODE
        </th>
     
        
        <th>
        ATTIVO
        </th>
        <th>
          UTILIZZATO
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr class="pointer"  v-for="(item, index) in filteredItems" :key="index">
        <td>
          {{ index+1 }}
        </td>
        
        <td>
          {{ item.create_at}}
        </td>

        <td>
          {{item.total}}
        </td>
        <td>
          {{item.payment}}
        </td>
        
        <td>
            {{item.reference}}
        </td>
          
        <td>
          {{item.tel}}
        </td>
        <td>
          {{item.expire_at}}  
        </td>
        <td>
          {{ item.barcode }}
         </td>
  
         
        <td>

          <i v-if="item.active==1" style="color:green" class="fas fa-check " aria-hidden="true"></i>
          <i v-if="item.active==0" style="color:red" class="fas fa-ban" aria-hidden="true"></i>
            
         </td>
         <td>
          {{ item.used_at }}
         </td>
        <td>
            <!-- CUSTOM SCALIA-->
            <button v-if="company.Id == 48" type="button" @click="EpsonCoupon(item)" class="btn btn-light ">
              <i style="color:darkgreen" class="fas fa-print mr-2" aria-hidden="true"></i>    
                STAMPA COUPON
            </button>
            <button v-if="company.Id == 48" type="button" @click="setFiscalData(item.couponId)" class="btn btn-light ml-4">
              <i style="color:brown" class="fas fa-print mr-2" aria-hidden="true"></i>    
                STAMPA SCONTRINO FISCALE
            </button>
          <div v-else class="dropdown">
                    <button style="color:black;background-color: white;" class="btn btn-info dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false">
                        <i class="fas fa-cog mr-2" aria-hidden="true"></i>
                        OPZIONI
                    </button>
                    <div class="dropdown-menu ">
                    <!--    
                    <a v-bind:class="{ disabled: isAdmin==0 }"   class="dropdown-item" @click="setCoupon(item)" href="#">
                      <i style="color:brown" class="fas fa-ban mr-2" aria-hidden="true"></i>
                        Disattiva coupon
                    </a>
                  -->
                   
                    <a  v-bind:class="{ disabled: false }"   class="dropdown-item" @click="updateCoupon(item)" href="#">
                      <i style="color:brown" class="fas fa-edit mr-2" aria-hidden="true"></i>
                        MODIFICA COUPON
                    </a>
                    
                    <a  v-if="btn" v-bind:class="{ disabled: false }"   class="dropdown-item" @click="printTicket(item)" href="#">
                      <i style="color:blueviolet" class="fas fa-print mr-2" aria-hidden="true"></i>
                        STAMPA COUPON
                    </a>

                    <a v-if="fiscalPrinter.fpId == 1 && item.payment.length > 0"  v-bind:class="{ disabled: !item.payment }"   class="dropdown-item" @click="printFiscalReceipt(item)" href="#">
                      <i style="color:green" class="fas fa-print mr-2" aria-hidden="true"></i>
                        STAMPA SCONTRINO FISCALE COUPON 
                    </a>
                    <a v-if="fiscalPrinter.fpId == 1"  v-bind:class="{ disabled: false }"   class="dropdown-item" @click="printEpsonCoupon(item)" href="#">
                      <i style="color:blue" class="fas fa-print mr-2" aria-hidden="true"></i>
                        STAMPA GESTIONALE COUPON 
                    </a>

                                          
                    </div>
            </div>
        </td>
    
      </tr>
    </tbody>
  </table> 
 </div>





  <label for="cerca">
  <i style="color:navy" class="fas fa-filter mr-2 mt-4" aria-hidden="true"></i>  
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">     
  </div>

</div>
</div>
</div>

<div v-else-if="type=='B'">

<div class="row_">  

<div v-if="!updateForm" class="col_">
  <coupon-form @update-return-button="$emit('update-return-button',$event)" @update="setData()"  v-bind:cart="cart"></coupon-form>
</div>
<div v-if="updateForm" class="col_">
  <CouponFormUpdate  v-if="updateForm" @close="setData()" v-bind:item="coupon"></CouponFormUpdate>
</div>


</div>
    
</div>

<div v-else-if="type=='C'">
  <searchForm @close="type='A'" @update="setDataItems" ></searchForm>
</div>



<!-- LIST -->


</div>
</template>

<script>
import api                       from '@/api';
import { mapGetters }            from 'vuex';
import JSPM                      from 'jsprintmanager'



import couponForm                from './CouponForm.vue' 
import fmt                       from '@/components/mixins/fmt.js'
// import {setFmtDate1}             from '@/functions'
import receiptHeading            from '@/components/mixins/ReceiptHeading.js'
import fiscalPrinter             from '@/components/rt/FiscalPrinter.vue'

import EpsonFiscalReceiptCoupon  from '@/components/rt/EpsonFiscalReceiptCoupon.vue'
import EpsonCoupon               from '@/components/rt/EpsonCoupon.vue'
import setPrint                  from '@/epson/xml.js'
import CouponFormUpdate          from './CouponFormUpdate.vue'
import modalMessage               from '@/components/modalDialog/ModalMessage.vue'         


import searchForm                from './CouponSearchForm';


export default {
  mixins:[fmt,receiptHeading,setPrint],
   props : ['cart'],
   components: {
     couponForm,fiscalPrinter,EpsonFiscalReceiptCoupon,EpsonCoupon,CouponFormUpdate,modalMessage,searchForm
   
  },
  
  data () {
    return {
    btn            : JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open,
   
    alert          : false, 
    items          : [],
    filterKey      : '',
    type           : 'A',
    receiptText    : [],
    deskId         : 1,
    fiscalPrinter  : {},
    fiscalData     : {},
    updateForm     : false,
    coupon         : {},
    fp             : false,
    fiscalCoupon   : {},
    epsonCoupon    : 0,
    printerIP      : '',
    

    }
  },
  computed: 
  {  
    ...mapGetters(['company','storeId','isAdmin']),
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     

  },
  watch: 
  {
    
  },
      
  async mounted()
  {

    this.printerIP = JSON.parse(localStorage.getItem("printerIP"))   
    const deskId = JSON.parse(localStorage.getItem("deskId"))    
    if(deskId)
    {    
      this.deskId = Number(deskId)
    
    }

    this.receiptText =  await this.getReceiptHeading(this.storeId,this.deskId)
    
    this.getData()
    this.getFiscalPrinter()

  },
  created()  
  {

    JSPM.JSPrintManager.auto_reconnect = true
    JSPM.JSPrintManager.start()
    
    
  }, 
  methods: 
    {
  
    setDataItems(items)
     {
      this.items = items
      this.type  = 'A'
     }, 
    searchCoupon()
    {
      this.type = 'C'
    },  
    closeEpsonCoupon()
    {
      this.epsonCoupon = 0
      
    },
    printEpsonCoupon(item)
    {
      
      this.coupon = item
      this.epsonCoupon = 1
      
      
    },
    async printFiscalReceipt(item)
    {
      //console.log(item)
      const data = await this.getCouponFiscalData(item.couponId,'epson')   
      
      this.fiscalCoupon = data
      this.fiscalPrinter.show = 1

      

    },  
    async getFiscalPrinter()
    {
    

    const sp    = {'sp':'spStoreDeskFiscalPrinter'}
    const data  = {'storeId':this.storeId,'deskId':this.deskId}      
    const json  = Object.assign(data, sp)
      
      //this.bt_spinner = true
      await api.post(json).then(res => {
      if(res.status==200)
        {
          
         if(res.data.recordsets[0].length > 0) 
         {
            this.fiscalPrinter = res.data.recordsets[0][0]
            
         }
         
        }
        else if(res.status==500)
        {
         
     
        
        } 
        else
        {
          
        
        } 
    }).catch(err => 
    {
      
     
       
    }).finally(() => {
      
    });

  

   },

  /* 
  setCoupon(data)
      {
        this.items.forEach(item=>{
          if(item.couponId == data.couponId)
          {
            item.reference = data.reference
            item.note      = data.note
            item.tel       = data.tel
            item.expire_at = setFmtDate1(data.expire_at)       
            item.barcode   = data.barcode     
          }
        })
        this.type = 'B'
        //this.updateForm = false

      },
   */   
   updateCoupon(item)
      {
        
        if(item.active)  
        {
          this.coupon = item         
          this.type = 'B'
          this.updateForm = true
        }  
        
      },
      /*
      closeUpdateForm()
      {
        this.updateForm = false
      },
      */
      async setFiscalData(couponId)
      {        
        
        const data = await this.getCouponFiscalData(couponId,'epson')
        const json = Object.assign(data, {'Id':couponId})    
        this.fiscalData  = json

        this.fp = true


      },
      setData()
      {
        this.type = 'A'
        this.getData()
      },
      createCoupon()
      {
        this.updateForm = false
        this.type = 'B'
      },

     

      getCouponFiscalData(couponId,type) 
      {
        
        const data  = {'couponId' : couponId,'type':type}
        const sp =    {'sp'       : 'spCouponFiscalData'}        
        const json = Object.assign(data, sp)        
        return new Promise( async (resolve) =>  {
        await api.post(json).then(res => {
          
          if(res.status==200)
            {   
                
                resolve(res.data.recordsets) 
               
            }
           else if(res.status==500)
           {
              
              
                resolve([])
                                    
           } 
           else
            {
                            
              resolve([])
            } 
          
          }).catch(err => {
              
            resolve([])
              
          }).finally(() => {
          
        });

      })
      },
      
      
      async getData() 
      {
               
        const sp       = 'spCompanyCouponList'
        const payload  = {'companyId' : this.company.Id,'storeId':this.storeId,'deskId':this.deskId,sp}        
        this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},1)  
     
        try{

       const res = await api.post(payload)


          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }
          this.items = res.data.recordsets[0] 
          this.$refs.msgModal.close()  

      }
      catch(err)   
      {
        const msg = err.message          
        this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)
      }



      },
     


      EpsonCoupon(coupon)
      {
      
      const crlf =  '\r\n'  
      const total = 0
      let txtFile = 'printerNonFiscal' + crlf
      txtFile += 'beginNonFiscal|1|' + crlf
      txtFile += 'printNormal|1|4|COUPON EURO ' + this.fmt1(coupon.total) +  crlf

      txtFile += 'printNormal|1|2|' + crlf
      txtFile += 'printNormal|1|4|DATA SCADENZA ' + coupon.expire_at +  crlf
      txtFile += 'printNormal|1|1|' + crlf
     
      txtFile += 'printNormal|1|1|' + crlf
      txtFile += 'printBarCode|1|901|3|120|BELOW|FontA|EAN13|' + coupon.barcode + crlf
      txtFile += 'endNonFiscal|1|' + crlf
      this.downLoadFile(txtFile)


     },
     downLoadFile(file)
     {
      const data  =  "data:text/csv;charset=utf-8," + file
                        
                var encodedUri = encodeURI(data)
                var link = document.createElement("a")
                link.setAttribute("href", encodedUri)
                link.setAttribute("download", "sco.txt")
                link.click()    
     },
      
      printTicket(coupon)
      {



      this.printerIP = JSON.parse(localStorage.getItem("printerIP"))   
      if(this.printerIP)  
      {
        this.setPrint('COUPON',coupon)
        return
      }


       function jspmWSStatus() {
            if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open)
                return true;
            else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
                alert('JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm');
                return false;
            }
            else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
                alert('JSPM has blocked this website!');
                return false;
            }
        }

   


    
    const GS = '\x1d'  
    const esc = '\x1B'; //ESC byte in hex notation
    const newLine = '\x0A'; //LF byte in hex notation

    let cmds = esc + "@"; //Initializes the printer (ESC @)
    //let cols = 48
    
   
   
    // HEADER 
    this.receiptText.forEach(row =>{
      if(row.type == 'H')
      {
        if(row.order_by == 1)
        {   
           // cols = row.cols   
                      
            cmds += esc + 'a' + '\x01'
            cmds += esc + '!' + '\x38'; //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
            cmds += row.text  //text to print
            cmds += newLine;
            
        }
        else
        {
            cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)
            cmds += row.text  //text to print
            cmds += newLine;
        }
        
      }

    })
    
    const total = this.fmt1(coupon.total)
    cmds += newLine;
    
    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)    
    cmds += newLine;
    cmds += GS + '!' +  '\x01'
    
    cmds += 'COUPON EURO'  //text to print
    cmds += newLine
   
    cmds += esc + 'a' + '\x01'
    cmds += esc + '!' + '\x38' 
    cmds += total   //text to print

    cmds += newLine
    cmds += newLine

    cmds += esc + '!' + '\x00'
    cmds += coupon.reference
    cmds += newLine

    cmds += esc + '!' + '\x00' //Character font A selected (ESC ! 0)    
    cmds += 'Valido fino al  '

    cmds += GS + '!' +  '\x01' //Emphasized + Double-height + Double-width mode selected (ESC ! (8 + 16 + 32)) 56 dec => 38 hex
    cmds += coupon.expire_at
    cmds += newLine


    cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)    
    
    // BARCODE  
    cmds += esc + 'a' + '\x01'
    cmds += GS  + 'h' + '\x50'
    cmds += GS  + 'H' + '\x02'
    cmds += GS  + 'f' + '\x01'
    cmds += GS  + 'k' + '\x02' + coupon.barcode + '\x00'
    
    //cmds += GS  + 'k' + '\x02' + '3701210432540' + '\x00'
    
    cmds += newLine
    cmds += newLine
    


    if(coupon.note)
    {
      cmds += GS + '!' +  '\x01'    
      cmds += coupon.note  //text to print
      cmds += newLine
      cmds += newLine
      cmds += newLine
      cmds += esc + '!' + '\x00'; //Character font A selected (ESC ! 0)   
    }




    cmds += coupon.create_at
    cmds += newLine

    // FOOTER
    this.receiptText.forEach(row=>{

      if(row.type=='F')
      {
        if(row.order_by > 0)
        {
          cmds += row.text   //text to print
          cmds += newLine
        }

      }
    })

    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine
    cmds += newLine

    cmds += GS + 'V' + '\x01'   
    cmds += newLine
    
  
    if (jspmWSStatus()) {
            //Create a ClientPrintJob
            var cpj = new JSPM.ClientPrintJob();
            cpj.clientPrinter = new JSPM.DefaultPrinter();
            
            /*
            //Set Printer type (Refer to the help, there many of them!)
            if ($('#useDefaultPrinter').prop('checked')) {
                cpj.clientPrinter = new JSPM.DefaultPrinter();
            } else {
                cpj.clientPrinter = new JSPM.InstalledPrinter($('#installedPrinterName').val());
            }
            */
          
            cpj.printerCommands = cmds;
            //Send print job to printer!
            cpj.sendToClient();
            

     }




  },
  

    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 600px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}



















.table thead tr:nth-child(1) th {
  top         : 0px;   
  z-index     : 30;
  position    : sticky;
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2;
  

}



/*
.table thead tr.sticky-row th {
  position          : sticky;
  top               : 0;
  background-color  : #fff; 
  z-index           : 10; 
  box-shadow        : 0 2px 2px -1px rgba(0,0,0,0.2); 
}
*/

.table thead tr:nth-child(3) th {
  color       : rgb(16, 16, 15) !important;
  background  : #a9cbe2 !important;

}


a,th{
  font-family : 'Roboto Condensed';
  font-size   : 15px;
 
}

input[type='checkbox'] {
 
  cursor         : pointer;
 
}
.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
tr{
  cursor: pointer;
}

.pointer:hover
{
  background-color : blue;
  color            : white;
  cursor           : pointer;
}

.dropdown-menu a:hover
{
  background-color: blue;
  color:white;
}
.card-header
{
  height: 45px;
}

.table,
.table th, 
.table td
{
  border-color: #3b28a7 !important;
}

.table {
  border-collapse: separate;
}

.fa-edit
{
  color : black
}
.fa-binoculars
{
  color : black
}
</style>